import { gql } from '../../../apollo/__generated__';

export const LEAVE_BEDROOM = gql(`
  mutation LeaveBedroom($bedroomId: ID!, $eventId: ID!) {
    leaveBedroom(bedroomId: $bedroomId, eventId: $eventId) {
      id
      floor
      doorNumber
      maxUsers
      users(eventId: $eventId) {
        id
        firstname
        lastname
        nickname
        studyTown
      }
    }
  }
`);
